module.exports = {
      id: "whatsappicon-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#whatsappicon",
      toString: function () {
        return this.url;
      }
    }